'use client';

import { CacheProvider } from '@emotion/react';
import { ReactNode, useState } from 'react';

import { createEmotionCache } from './createEmotionCache';

export default function EmotionRegistry({
  children,
  cacheKey
}: {
  children: ReactNode;
  cacheKey: string;
}) {
  const [cache] = useState(() => createEmotionCache(cacheKey));

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
